<template>
  <section>
    <h4>{{ title }}</h4>
    <h5 v-if="content">{{ content }}</h5>
    <h5 v-if="content2">{{ content2 }}</h5>
    <slot />
    <p v-if="note">{{ note }}</p>
  </section>
</template>

<script>
export default {
  props: ["title", "content", "content2", "note"],
}
</script>

<style lang="scss" scoped>
section {
  h4 {
    margin: 20px 0 7px 0;
    font-size: 0.8rem;
  }
  h5 {
    user-select: text;
    white-space: pre-wrap;
    line-height: 1.2;
    &:last-child {
      margin-bottom: 10px;
    }
  }
  a,
  p,
  h5 {
    font-size: 0.9rem;
  }
  a {
    color: $blue;
  }
}
</style>
